import React, {Component} from 'react';
import Header from '../components/Header';

export default class Cookies extends Component {
  render() {
    return (
        <div>
          <Header title="Cookies"/>
          <div className="container">
            <p>Fristberegneren anvender cookies til indsamling af statistik og forbedring af brugervenligheden på hjemmesiden. Ved at klikke videre og anvende værktøjet accepterer du automatisk brugen af disse.</p>
            <p>Cookies anvendes af stort set alle hjemmesider, og i nogle tilfælde er cookies den eneste måde at få en hjemmeside til at fungere efter hensigten. En cookie er en fil, som gemmes i din browser på din computer, tablet eller smartphone. Den gør det muligt at genkende din computer og samle information om hvilke sider og funktioner, der besøges med din browser. Men cookies kan ikke se, hvem du er, hvad du hedder, hvor du bor eller om computeren bruges af en eller flere personer. Den kan heller ikke sprede computervirus eller andre skadelige programmer. </p>
            <p>Du kan altid ændre indstillingerne i din browser og dermed afvise cookies på din computer. Opsætning af indstillinger er afhængig af, hvilken browser du vælger at anvende, men alle browsere tillader, at cookies bliver slettet enkeltvis eller samlet. Vær opmærksom på, at der er funktioner og services du ikke kan benytte på internettet, hvis du afviser cookies. </p>
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Cookies.js